import { CreateRoundRequest, CreateRoundResponse, Round } from '../models/round';

class RoundService {
    public async createRound(roundName: string) {
        try {
            const request: CreateRoundRequest = {
                name: roundName,
            };
            const response = await fetch(`${process.env.REACT_APP_BASE_API_URL!}/rounds`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(request),
            });
            if (!response.ok) {
                throw new Error(`Failed to create round: ${response.status} ${response.statusText}`);
            }

            return {
                body: await response.json() as CreateRoundResponse,
                status: response.status,
            };
        } catch (error) {
            console.log(error);
            throw error;
        }
    }

    public async getRound(roundId: string) {
        let url = `${process.env.REACT_APP_BASE_API_URL!}/rounds/${roundId}`;

        try {
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            if (!response.ok) {
                throw new Error(`Failed to get round: ${response.status} ${response.statusText}`);
            }
            return {
                body: await response.json() as Round,
                status: response.status,
            };
        } catch (error) {
            console.log(error);
            throw error;
        }
    }

    public async attachPlayerToRound(roundId: string, playerId: string) {
        try {
            const response = await fetch(`${process.env.REACT_APP_BASE_API_URL!}/rounds/${roundId}/players`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ playerId }),
            });
            if (!response.ok) {
                throw new Error(`Failed to attach player to round: ${response.status} ${response.statusText}`);
            }
            return {
                body: await response.json(),
            };
        } catch (error) {
            console.log(error);
            throw error;
        }
    }

    public async updatePlayerRoundStatus(roundId: string, playerId: string, status: string) {
        try {
            const response = await fetch(`${process.env.REACT_APP_BASE_API_URL!}/rounds/${roundId}/players/${playerId}/status`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ status }),
            });
            if (!response.ok) {
                throw new Error(`Failed to update player round status: ${response.status} ${response.statusText}`);
            }
            return {
                body: await response.json(),
            };
        } catch (error) {
            console.log(error);
            throw error;
        }
    }

    public async recordScore(roundId: string, playerId: string, holeNumber: number, score: number) {
        try {
            const response = await fetch(`${process.env.REACT_APP_BASE_API_URL!}/rounds/${roundId}/players/${playerId}/scores/${holeNumber}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ score }),
            });
            if (!response.ok) {
                throw new Error(`Failed to record score: ${response.status} ${response.statusText}`);
            }
            return {
                body: await response.json(),
            };
        } catch (error) {
            console.log(error);
            throw error;
        }
    }
}

export const roundService = new RoundService();